'use strict'
const calcAnnoucementHeight = () => {
  let e = document.getElementById('shopify-section-announcement-bar')
  if (e) {
    let t = `${e.getBoundingClientRect().bottom}px`
    document.getElementById('shopify-section-header')
    document.documentElement.style.setProperty('--under-announcement', t)
  }
}
function initEqCustomMenuClose() {
  let e = document.getElementsByClassName('header__icon--menu'),
    t = document.getElementById('eq-custom-close-span'),
    n = document.getElementById('sidemenu-overlay'),
    l = document.getElementsByTagName('html')[0]
  e[0] &&
    e[0].addEventListener('click', () => {
      l.classList.toggle('overflow-hidden'), calcAnnoucementHeight()
      let e = document.getElementsByClassName('mobile-nav-menu')
      e[0] && e[0].classList.toggle('hide-mobile-nav')
    }),
    t &&
      t.addEventListener('click', () => {
        let e = document.getElementsByClassName('header-drawer')
        e[0] && e[0].firstElementChild.firstElementChild.click()
      }),
    n &&
      n.addEventListener('click', () => {
        let e = document.getElementsByClassName('header-drawer')
        e[0] && e[0].firstElementChild.firstElementChild.click()
      })
}

window.addEventListener('load', () => {
  initEqCustomMenuClose(), calcAnnoucementHeight()
})
//# sourceMappingURL=mobile-nav.js.map
